import { createAction, props } from '@ngrx/store';

import { type AiUndoState } from '../../ai/chat/ai-undo.service';
import { type AICommandPayload } from '../../ai/chat/command-payload.model';
import { type EngineState } from '../engine';

export const executeAICommands = createAction(
  '[AI] Execute AI Commands',
  props<{ payload: AICommandPayload<any>[] }>(),
);

export const undoAICommands = createAction(
  '[AI] Undo AI Commands',
  props<{ state: AiUndoState }>(),
);

export const applyChanges = createAction(
  '[AI] Apply changes',
  props<{ state: Partial<EngineState> }>(),
);

export const updatePageAiDescription = createAction(
  '[AI] Update Page AI Description',
  props<{ pageId: string; aiDescription: string }>(),
);
